import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c7ef156"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "timeline-container" }
const _hoisted_2 = { class: "timeline-controls" }
const _hoisted_3 = { class: "control-buttons" }
const _hoisted_4 = ["title"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 512 512"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M64 496h120v-32H64a16.019 16.019 0 0 1-16-16V328H16v120a48.054 48.054 0 0 0 48 48ZM48 64a16.019 16.019 0 0 1 16-16h120V16H64a48.054 48.054 0 0 0-48 48v120h32Zm400-48H328v32h120a16.019 16.019 0 0 1 16 16v120h32V64a48.054 48.054 0 0 0-48-48Zm16 432a16.019 16.019 0 0 1-16 16H328v32h120a48.054 48.054 0 0 0 48-48V328h-32Zm-64-192c0-79.4-64.6-144-144-144s-144 64.6-144 144s64.6 144 144 144s144-64.6 144-144ZM256 368a112 112 0 1 1 112-112a112.127 112.127 0 0 1-112 112Z"
  })
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = ["disabled", "title"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "0.88em",
  height: "1em",
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 448 512"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M135.2 17.7C140.6 6.8 151.7 0 163.8 0h120.4c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64s14.3-32 32-32h96l7.2-14.3zM32 128h384v320c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z"
  })
], -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = ["disabled", "title"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "m16 5l5 5l-5 5" }),
    /*#__PURE__*/_createElementVNode("path", { d: "M21 10h-8C7.477 10 3 14.477 3 20v1" })
  ])
], -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = ["disabled", "title"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "m8 5l-5 5l5 5" }),
    /*#__PURE__*/_createElementVNode("path", { d: "M3 10h8c5.523 0 10 4.477 10 10v1" })
  ])
], -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "control zoom-text" }, "100%")
], -1))
const _hoisted_17 = { class: "zoom-slider" }
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "control zoom-text" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "time" }, null, -1))
const _hoisted_21 = { class: "time player-time" }
const _hoisted_22 = { class: "badge-button current-time" }
const _hoisted_23 = { class: "control" }
const _hoisted_24 = { class: "Panel timeline" }
const _hoisted_25 = {
  ref: "timeMark",
  class: "time-mark"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-mark" }, null, -1))
const _hoisted_27 = [
  _hoisted_26
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TimelineFrame = _resolveComponent("TimelineFrame")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        _createElementVNode("li", null, [
          _createElementVNode("button", {
            class: _normalizeClass(["control badge-button", {'inactive': _ctx.selectedAnimation == null}]),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.focusCurrentFrame && _ctx.focusCurrentFrame(...args))),
            title: _ctx.actions_go_to_lyric
          }, _hoisted_6, 10, _hoisted_4)
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("button", {
            class: _normalizeClass(["control badge-button", {'inactive': _ctx.selectedAnimation == null}]),
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.deleteAnimation && _ctx.deleteAnimation(...args))),
            disabled: _ctx.selected == null,
            title: _ctx.actions_delete_selected
          }, _hoisted_9, 10, _hoisted_7)
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("button", {
            class: _normalizeClass(["control badge-button", {'inactive': _ctx.selected == null}]),
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.moreCurrentToRight && _ctx.moreCurrentToRight(...args))),
            disabled: _ctx.selected == null,
            title: _ctx.actions_move_right
          }, _hoisted_12, 10, _hoisted_10)
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("button", {
            class: _normalizeClass(["control badge-button", {'inactive': _ctx.selected == null}]),
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.moreCurrentToLeft && _ctx.moreCurrentToLeft(...args))),
            disabled: _ctx.selected == null,
            title: _ctx.actions_move_left
          }, _hoisted_15, 10, _hoisted_13)
        ]),
        _hoisted_16,
        _createElementVNode("li", _hoisted_17, [
          _createElementVNode("input", {
            type: "range",
            min: "1",
            max: "1000",
            step: "50",
            class: "slider",
            value: _ctx.scale,
            onInput: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.zoomToScale && _ctx.zoomToScale(...args)))
          }, null, 40, _hoisted_18)
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.zoom), 1)
        ]),
        _hoisted_20,
        _createElementVNode("li", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.timeText) + " seg", 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", {
        class: "inner-timeline",
        onMousewheel: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onMouseWheel && _ctx.onMouseWheel(...args)))
      }, [
        _createElementVNode("canvas", {
          ref: "canvas",
          height: "32",
          width: "1291",
          style: {"position":"absolute"},
          onMousedown: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.canvasMousedown && _ctx.canvasMousedown(...args)))
        }, null, 544),
        _createElementVNode("div", {
          ref: "scroller",
          class: "Panel scroller",
          onScroll: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onScroll && _ctx.onScroll(...args))),
          style: {"background":"linear-gradient(rgb(68, 68, 68, 0.21) 1px, #ffffff 1px) 0% 0% / 64px 64px repeat"},
          onDblclick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.dblClick && _ctx.dblClick(...args)))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.animations, (anim) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: anim.id
            }, [
              (anim.isPose)
                ? (_openBlock(), _createBlock(_component_TimelineFrame, {
                    key: 0,
                    frame: anim,
                    onSelected: e=> _ctx.click(e, anim),
                    onMoused: e=> _ctx.mousedown(e, anim),
                    onResizeleftend: e=> _ctx.frameResized(e, anim),
                    onResizerightend: e=> _ctx.frameResized(e, anim)
                  }, null, 8, ["frame", "onSelected", "onMoused", "onResizeleftend", "onResizerightend"]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ], 544),
        _createElementVNode("div", _hoisted_25, _hoisted_27, 512)
      ], 32)
    ])
  ]))
}